export enum ActionTypes {
    SET_CHAT = "SET_CHAT",
    SET_CHAT_COUNT = "SET_CHAT_COUNT",
    SET_ERROR = "SET_ERROR",
    FETCH_CHAT = "FETCH_CHAT",
    FETCH_CHAT_COUNT = "FETCH_CHAT_COUNT",
}